<script>
/**
 * Widget-stat component -- specify the widget title, image, value, subtext and color of subtext.
 */
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    subText: {
      type: [String, Number],
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    backgroundMini:{
      type: String
    },
    background: {
      type: String
    }
  }
};
</script>

<template>
  <div class="card mb-0 mini-stat text-white" :class="`bg-${color}`" :style="{backgroundColor: background}">
    <div class="card-body p-2">
      <div>
        <div class="float-start mini-stat-img me-2">
          <img :src="`${image}`" alt />
        </div>
        <h5 class="font-size-16 text-uppercase mt-0">{{$t(title)}}</h5>
        <h4 class="fw-medium font-size-24">
          {{value}}
          <i class="mdi mdi-arrow-up text-white ms-2"></i>
        </h4>
        <div :class="`mini-stat-label ${backgroundMini}`" :style="{backgroundColor: background ? 'rgb(0 0 0 / 10%)' : ''}">
          <p class="mb-0">{{subText}}%</p>
        </div>
      </div>
      <div class="pt-2">
        <div class="float-end">
          <a href="#" class="text-white-50">
            <i class="mdi mdi-arrow-right h5"></i>
          </a>
        </div>
        <p class="text-white-50 mb-0 mt-1">Since last day</p>
      </div>
    </div>
  </div>
</template>
